import React, {useEffect, useRef} from 'react'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/themes/light.css'
import 'flatpickr/dist/l10n/vn.js'
import '../assets/scss/plugins/forms/flatpickr/flatpickr.scss'
import {FormGroup, Label} from 'reactstrap'
import {getPropObject} from '../configs/app-configs'
import {useIntl} from "react-intl";
import moment from "moment";

const DatePicker = (props) => {
  const intl = useIntl()
  const datePickerRef = useRef()

  useEffect(() => {
    const instance = flatpickr(datePickerRef.current, {
      locale: intl.locale === 'vi' ? flatpickr.l10ns.vn : '',
      allowInput: false,
      defaultDate: props.value,
      onChange: (value) => props.onChange(value),
      onClose: (value) => props.onClose && props.onClose(value),
      ...props.options
    })
    datePickerRef.current.value = instance.input.value
  }, [props.value])


  return (
    <FormGroup className='form-label-group position-relative'>
      <input ref={datePickerRef} disabled={props.disabled} placeholder={props.placeholder}
             className={`form-control position-relative bg-white flatpickr-input ${props.className}`}/>
      <Label>{props.placeholder}</Label>
      {props.errors &&
      props.touched &&
      getPropObject(props.errors, props.fieldName) &&
      getPropObject(props.touched, props.fieldName) ? (
        <div className='text-danger'>{getPropObject(props.errors, props.fieldName)}</div>
      ) : null}
    </FormGroup>
  )
}

export default DatePicker
